import { render, staticRenderFns } from "./KTab.vue?vue&type=template&id=158d336d&"
import script from "./KTab.vue?vue&type=script&lang=js&"
export * from "./KTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports